export const MESSAGE_ERROR = {
	DUPLICATED: 'Duplicated field',
};
